import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ProductService } from "src/app/services/product.service";
import { SharedModule } from "src/app/shared/shared.module";
import { Router, NavigationEnd } from "@angular/router";
import { ViewportScroller } from "@angular/common";
import { filter } from "rxjs/operators";
import { ApiService } from "src/app/services/api.service";
@Component({
  selector: "app-product-view",
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  templateUrl: "./product-view.component.html",
  styleUrls: ["./product-view.component.css"],
})
export class ProductViewComponent implements OnInit {
  product: any;
  newEstateForm!: FormGroup;
  isLoaded: boolean = false;
  isSuccess: boolean = false;
  isError: boolean = false;
  errorMessage: string = "";
  showModal = false;

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private productService: ProductService,
    private router: Router,
    private viewportScroller: ViewportScroller
  ) {
    this.newEstateForm = this.fb.group({
      email: ["", Validators.required],
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      estateName: ["", Validators.required],
      estateLocation: ["", Validators.required],
      applicantCategory: ["", Validators.required],
      phoneNumber: ["", Validators.required],
    });
  }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.product = this.productService.getProductById(id);
    }

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.viewportScroller.scrollToPosition([0, 0]); // scrolls to top
      });
  }

  states = ["Abuja", "Lagos", "Kano", "Kaduna", "Oyo", "Rivers"];

  estate = {
    estateName: "",
    state: "",
    address: "",
    email: "",
    phone: "",
  };

  onSubmit() {
    if (this.newEstateForm.valid) {
      this.isLoaded = true;
      const data = this.newEstateForm.value;
      console.log(data);

      this.apiService.addEstateToWaitList(data).subscribe(
        (response) => {
          this.errorMessage = "";
          console.log("Estate added to waitlist successfully", response);
          console.log("Form submitted");
          this.isLoaded = false;
          this.isSuccess = true;
          this.newEstateForm.reset();
        },
        (error) => {
          this.errorMessage = error.error.message;
          console.log("Error adding estate to waitlist", error);
          this.isLoaded = false;
        }
      );
    } else {
      this.isLoaded = false;
      console.log("Form invalid");
    }
  }

  closeModal() {
    this.showModal = false;
    this.isSuccess = false;
  }
}
